"use client"

import { StyledLink } from "@/components/StyledLink"
import {
  Box,
  Container,
  Typography,
  Select,
  MenuItem,
  LinearProgress,
  Card,
  CardContent,
  Button,
  Grid,
  Paper,
  Chip,
  IconButton,
  FormControl,
  InputLabel,
  Stack,
  Link,
} from "@mui/material"
import { ChevronLeft, ChevronRight, ExpandIcon as ExpandMore, ExternalLink } from "lucide-react"
import { useState } from "react"
import { useNavigate } from "react-router"
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import timeGridPlugin from "@fullcalendar/timegrid"
import listPlugin from "@fullcalendar/list"
import EducatorSchedule from "./components/Schedule"
import EducatorTopic from "./components/Topic"
import EducatorTCC from "./components/ThoughtCoCreate"
import MyCourse from "./components/MyCourse"
import EducatalystWidget from "./components/Educatalyst"
import CommunityHighLightWidget from "./components/CommunityHighLight"

// Calendar type definition
type CalendarEvent = {
    date: string
    type: string
    title: string
  }

// Trending topic type
type TrendingTopic = {
  title: string
  author: string
  likes: number
  comments: number
  views: number
  tags: string[]
}

export default function EducatorDashboard() {
    const navigate = useNavigate();

  const trendingTopics: TrendingTopic[] = [
    {
      title: "Best practices for teaching robotics to beginners",
      author: "Jane Doe",
      likes: 42,
      comments: 15,
      views: 230,
      tags: ["robotics", "teaching"],
    },
    {
      title: "Integrating AI concepts into STEM curriculum",
      author: "John Smith",
      likes: 38,
      comments: 22,
      views: 185,
      tags: ["AI", "STEM"],
    },
    {
      title: "Creative ways to use Blockly in the classroom",
      author: "Alice Johnson",
      likes: 56,
      comments: 30,
      views: 310,
      tags: ["Blockly", "creativity"],
    },
  ]

  const calendarEvents: CalendarEvent[] = [
    { date: "2025-04-15", type: "Workshop", title: "Workshop" },
    { date: "2025-04-21", type: "ThoughtCoCreate", title: "ThoughtCoCreate" },
  ]

  return (
    <Box sx={{ py: 0 }}>
      <Grid container spacing={3} sx={{ mt: 3 }}>
        <Grid item xs={12} md={8}>
          {/* <EducatorSchedule /> */}
          <EducatorTCC />
          {/* <MyCourse /> */}
          <EducatorSchedule/>
        </Grid>

        <Grid item xs={12} md={4}>
          <EducatalystWidget />
          <CommunityHighLightWidget />
        </Grid>
      </Grid>
    </Box>
  )
}

